(function () {
  const MAX_RETRIES = 10;
  const RETRY_DELAY = 300; // ms
  let retries = 0;
  let formattedPrices = null;
  let unitPrices = null;
  let enforceRunId = 0; // cancels older enforcement loops when a new price is set
  let ctaEnforceRunId = 0; // cancels older CTA enforcement loops

  function getSellingPlanId() {
    const spInput = document.querySelector(
      'form[action*="/cart/add"] input[name="selling_plan"]',
    );
    return spInput ? spInput.value : "";
  }

  const STICKY_SCOPE = ".sticky-atc-bar";

  function $stickyOne(sel) {
    const r = document.querySelector(STICKY_SCOPE);
    return r ? r.querySelector(sel) : null;
  }
  function $stickyAll(sel) {
    const r = document.querySelector(STICKY_SCOPE);
    return r ? Array.from(r.querySelectorAll(sel)) : [];
  }

  function getPrimaryCtaButton() {
    return Array.from(
      document.querySelectorAll(".product-form__cart-submit[data-add-to-cart]"),
    ).find(
      (btn) =>
        !btn.closest(STICKY_SCOPE) && !btn.closest(".quick-product-modal"),
    );
  }

  function syncStickyCtaFromPrimary() {
    const primaryBtn = getPrimaryCtaButton();
    const stickyBtn = $stickyOne(
      ".product-form__cart-submit[data-add-to-cart]",
    );
    if (!primaryBtn || !stickyBtn) return;

    ["[data-add-to-cart-price]", "[data-add-to-cart-compare-price]"].forEach(
      (selector) => {
        const sourceEl = primaryBtn.querySelector(selector);
        const targetEl = stickyBtn.querySelector(selector);
        if (!sourceEl || !targetEl) return;
        if (targetEl.innerHTML !== sourceEl.innerHTML) {
          targetEl.innerHTML = sourceEl.innerHTML;
        }
      },
    );
  }

  function scheduleStickyCtaSync({ attempts = 6, interval = 150 } = {}) {
    let tries = 0;

    const tick = () => {
      syncStickyCtaFromPrimary();
      tries += 1;
      if (tries < attempts) setTimeout(tick, interval);
    };

    setTimeout(tick, interval);
  }

  function toTwoDecimals(text) {
    if (typeof text !== "string") return text;
    const m = text.match(/^(\D*)(\d+(?:\.\d+)?)/);
    if (!m) return text;
    const symbol = m[1] || "";
    const val = parseFloat(m[2]);
    if (!isFinite(val)) return text;
    return symbol + val.toFixed(2);
  }

  function stripHtml(text) {
    if (typeof text !== "string") return text;
    if (!text.includes("<")) return text;
    const tmp = document.createElement("span");
    tmp.innerHTML = text;
    return tmp.textContent || "";
  }

  function formatMoneyValue(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(
        cents,
        window.theme?.moneyFormat ||
          window.Shopify?.money_format ||
          "${{amount}}",
      );
    }
    const num = Number(cents);
    if (!isFinite(num)) return "";
    return "$" + (num / 100).toFixed(2);
  }

  function formatMoneyNoTrailingZeros(cents) {
    const formatted = formatMoneyValue(cents);
    return stripHtml(formatted)
      .replace(/\.00$/, "")
      .replace(/(\.\d*?[1-9])0+$/, "$1")
      .trim();
  }

  function updateCtaPrice(variant) {
    if (!variant) return;
    const price = Number(variant.price);
    if (!isFinite(price)) return;
    if (
      document.querySelector(
        'form[action*="/cart/add"] input[name="selling_plan"]',
      )
    ) {
      return;
    }

    const formatted = formatMoneyNoTrailingZeros(price);
    document.querySelectorAll("[data-add-to-cart-price]").forEach((el) => {
      if (el.textContent.trim() !== formatted) el.textContent = formatted;
    });

    document
      .querySelectorAll(".sticky-atc-bar span[data-price]")
      .forEach((el) => {
        if (el.textContent.trim() !== formatted) el.textContent = formatted;
      });

    scheduleCtaPriceEnforce(formatted);
    scheduleStickyCtaSync();
  }

  function setDisplayedPrice(text) {
    function normalizeMoney(s) {
      if (typeof s !== "string") return s;
      let out = s.trim();
      out = out.replace(/\.00$/, "");
      out = out.replace(/(\.\d*?[1-9])0+$/, "$1");
      return out;
    }

    const cleaned = stripHtml(text);
    const stickyClean = normalizeMoney(cleaned);
    const buyboxFixed = toTwoDecimals(cleaned);

    writeDisplayedPrice(stickyClean, buyboxFixed);

    schedulePriceEnforce(stickyClean, buyboxFixed, {
      attempts: 6,
      interval: 200,
    });
  }

  function writeDisplayedPrice(stickyClean, buyboxFixed) {
    $stickyAll("span[data-price]").forEach((el) => {
      if (el.textContent.trim() !== stickyClean) el.textContent = stickyClean;
    });
    $stickyAll("[data-add-to-cart-price]").forEach((el) => {
      if (el.textContent.trim() !== stickyClean) el.textContent = stickyClean;
    });

    document.querySelectorAll("[data-add-to-cart-price]").forEach((el) => {
      if (el.closest(STICKY_SCOPE)) return;
      if (el.textContent.trim() !== buyboxFixed) el.textContent = buyboxFixed;
    });
  }

  function schedulePriceEnforce(
    expectedSticky,
    expectedBuybox,
    { attempts = 5, interval = 200 } = {},
  ) {
    const runId = ++enforceRunId;
    let tries = 0;

    const tick = () => {
      if (runId !== enforceRunId) return;

      let diverged = false;

      $stickyAll("span[data-price]").forEach((el) => {
        if (el.textContent.trim() !== expectedSticky) diverged = true;
      });
      $stickyAll("[data-add-to-cart-price]").forEach((el) => {
        if (el.textContent.trim() !== expectedSticky) diverged = true;
      });

      document.querySelectorAll("[data-add-to-cart-price]").forEach((el) => {
        if (el.closest(STICKY_SCOPE)) return;
        if (el.textContent.trim() !== expectedBuybox) diverged = true;
      });

      if (diverged) writeDisplayedPrice(expectedSticky, expectedBuybox);

      tries += 1;
      if (tries < attempts) setTimeout(tick, interval);
    };

    setTimeout(tick, interval);
  }

  function scheduleCtaPriceEnforce(
    expected,
    { attempts = 6, interval = 150 } = {},
  ) {
    const runId = ++ctaEnforceRunId;
    let tries = 0;

    const tick = () => {
      if (runId !== ctaEnforceRunId) return;

      let diverged = false;

      document.querySelectorAll("[data-add-to-cart-price]").forEach((el) => {
        if (el.textContent.trim() !== expected) diverged = true;
      });
      document
        .querySelectorAll(".sticky-atc-bar span[data-price]")
        .forEach((el) => {
          if (el.textContent.trim() !== expected) diverged = true;
        });

      if (diverged) {
        document.querySelectorAll("[data-add-to-cart-price]").forEach((el) => {
          if (el.textContent.trim() !== expected) el.textContent = expected;
        });
        document
          .querySelectorAll(".sticky-atc-bar span[data-price]")
          .forEach((el) => {
            if (el.textContent.trim() !== expected) el.textContent = expected;
          });
      }

      tries += 1;
      if (tries < attempts) setTimeout(tick, interval);
    };

    setTimeout(tick, interval);
  }

  function buildUnitPriceMap(formattedPrices) {
    const map = {};
    Object.keys(formattedPrices || {}).forEach((vId) => {
      const v = formattedPrices[vId];
      if (v?.unit) map[vId] = v.unit;
    });

    const variants = ShopifyAnalytics?.meta?.product?.variants || [];
    variants.forEach((v) => {
      const vId = String(v.id);
      if (!map[vId]) {
        if (window.Shopify && typeof Shopify.formatMoney === "function") {
          map[vId] = stripHtml(
            Shopify.formatMoney(
              v.price,
              window.theme?.moneyFormat ||
                window.Shopify?.money_format ||
                "${{amount}}",
            ),
          );
        } else {
          map[vId] = "$" + (Number(v.price) / 100).toFixed(2);
        }
      }
    });

    return map;
  }

  function logPrices(variantId, planId) {
    if (!variantId || !formattedPrices) {
      console.warn(
        "[StickyDiag] logPrices called without variantId or formattedPrices",
      );
      return;
    }

    lastState = { variantId, planId };

    const variantData = formattedPrices[variantId];

    if (!variantData) {
      // No subscription plan
      const unitText = unitPrices?.[String(variantId)];
      if (unitText) setDisplayedPrice(unitText);
      return;
    }

    if (!planId) {
      // One time purchase selected
      setDisplayedPrice(variantData.unit);
      return;
    }

    const planData = variantData.sellingPlans?.[planId];
    if (planData) {
      // Subscrition plan selected
      setDisplayedPrice(planData.price);
    } else {
      console.warn(
        `[StickyDiag] plan ${planId} not found for variant ${variantId}`,
      );
    }
  }

  function startSellingPlanWatcher() {
    let last = getSellingPlanId();
    setInterval(() => {
      const current = getSellingPlanId();
      if (current !== last) {
        last = current;
        const vId = ShopifyAnalytics?.meta?.selectedVariantId || null;
        logPrices(vId, current);
      }
    }, 250);
  }

  function addDiscount() {
    // Proper wait until recharge widget loads
    setTimeout(() => {
      addDiscount();
    }, 1000);

    document
      .querySelectorAll("recharge-subscription-widget")
      .forEach((widget) => {
        const sr = widget.shadowRoot;
        if (!sr) return;

        const subOpt = sr.querySelector(".rc-purchase-option__subscription");
        if (!subOpt) return;

        const selector = subOpt.querySelector(
          '[part*="rc-purchase-option__selector"]',
        );
        const labelEl = selector?.childNodes[selector.childNodes.length - 1];

        function parsePrice(el) {
          if (!el) return null;
          return Number(el.textContent.replace(/[^0-9.]/g, ""));
        }

        function updateLabel() {
          const origEl = subOpt.querySelector(
            '[part~="rc-purchase-option__original-price"]',
          );
          const discEl = subOpt.querySelector(
            '[part~="rc-purchase-option__discounted-price"]',
          );
          const orig = parsePrice(origEl);
          const disc = parsePrice(discEl);

          if (orig && disc && disc < orig && labelEl) {
            const pct = Math.round((1 - disc / orig) * 100);
            labelEl.textContent = ` ${pct}%`;
          }
        }

        updateLabel();
        new MutationObserver(updateLabel).observe(subOpt, {
          childList: true,
          subtree: true,
        });
      });
  }

  function rechargeInit() {
    const map = window.SubscriptionWidgetConfig?.formattedPrices;
    const spInput = document.querySelector(
      'form[action*="/cart/add"] input[name="selling_plan"]',
    );
    const variantId = ShopifyAnalytics?.meta?.selectedVariantId || null;

    if (!map || !spInput || !variantId) {
      if (retries < MAX_RETRIES) {
        retries++;
        const delay = RETRY_DELAY * retries;
        setTimeout(rechargeInit, delay);
      } else {
        console.warn("[StickyDiag] init failed: elements not ready");
      }
      return;
    }

    formattedPrices = map;
    unitPrices = buildUnitPriceMap(formattedPrices);

    document.addEventListener("product:variant-change", function (evt) {
      if (!evt.detail?.variant) return;
      addDiscount();
      const hasPlans = !!formattedPrices?.[evt.detail.variant.id];
      const planId = hasPlans ? getSellingPlanId() : "";
      logPrices(evt.detail.variant.id, planId);
    });

    startSellingPlanWatcher();

    const planId = getSellingPlanId();
    logPrices(variantId, planId);
  }

  document.addEventListener("DOMContentLoaded", () => {
    rechargeInit();
    addDiscount();
  });

  document.addEventListener("product:variant-change", function (evt) {
    updateCtaPrice(evt.detail?.variant);
  });
})();
